var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"duplicate-item-btn",attrs:{"title":"کپی"},on:{"click":function($event){return _vm.duplicateItem()}}},[_c('b-icon',{attrs:{"icon":"files"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }